import {
  CATEGORIES,
  STORAGE_IDENTIFIERS,
  THD_LOCALIZER,
  TIMESPANS,
} from "../common/constants";
import cookie from "./methods/cookie";

export const getThdLocalizer = () => {
  const thdLocalizerString = cookie.get(THD_LOCALIZER);

  if (!thdLocalizerString) {
    return null;
  }

  try {
    const thdLocalizer = JSON.parse(decodeURIComponent(thdLocalizerString));
    const entries = Object.fromEntries(
      Object.values(STORAGE_IDENTIFIERS.THD_LOCALIZER).map((value) => [
        value,
        thdLocalizer[value],
      ])
    );
    return entries;
  } catch (e) {
    console.error("Error in parsing THD_LOCALIZER cookie " + e);
    return null;
  }
};

export const setThdLocalizer = ({ entries, fromScratch = false }) => {
  try {
    let thdLocalizer = {};
    if (!fromScratch) {
      thdLocalizer = getThdLocalizer();
    }
    Object.keys(entries).forEach((key) => {
      thdLocalizer[key] = entries[key];
    });
    const value = JSON.stringify(thdLocalizer);

    const isSelfLocalized =
      thdLocalizer[STORAGE_IDENTIFIERS.THD_LOCALIZER.THD_FORCE_LOC] ===
      CATEGORIES.THD_FORCE_LOC.SELF_LOCALIZED;

    cookie.put({
      key: THD_LOCALIZER,
      value,
      expireTime: isSelfLocalized ? TIMESPANS.ONE_YEAR : TIMESPANS.SESSION,
    });
  } catch (e) {
    console.error("Error in creating THD_LOCALIZER cookie " + e);
  }
};
